
(
  /**
   * The `initCartSync` function initializes a cart synchronization feature by fetching cart data,
   * listening for specific URLs related to cart changes, and updating the local and global cart data
   * accordingly.
   */
  async function initCartSync() {
    /**
     * The function `getCart` fetches a JSON file containing the cart data and returns it as a promise.
     * @returns The function `getCart()` returns a Promise that resolves to the JSON data fetched from
     * the "/cart.json" endpoint if the fetch request is successful (status code 200). If the fetch
     * request fails, it throws an Error with a message indicating the failure.
     */
    async function getCart() {
      const result = await fetch("/cart.json")

      if (result.status === 200) {
        return result.json()
      }

      throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`)
    }

    async function signalKlaviyo(data) {
      const shiftDecimal = (digits) => (digits / 100)

      klaviyo.track("Added to Cart", {
        "$value": shiftDecimal(data.final_price),
        "AddedItemProductName": data.product_title,
        "AddedItemProductID": data.product_id,
        "AddedItemSKU": data.sku,
        "AddedItemCategories": [data.product_type],
        "AddedItemImageURL": data.image,
        "AddedItemURL": `${window.location.origin}${data.url}`,
        "AddedItemPrice": shiftDecimal(data.price),
        "AddedItemQuantity": 1,
        "ItemNames": [data.product_title],
        "CheckoutURL": `${window.location.origin}/checkouts`,
        "Items": [{
          "ProductID": data.product_id,
          "SKU": data.sku,
          "ProductName": data.product_title,
          "Quantity": 1,
          "ItemPrice": shiftDecimal(data.price),
          "RowTotal": shiftDecimal(data.final_price),
          "ProductURL": `${window.location.origin}${data.url}`,
          "ImageURL": data.image,
          "ProductCategories": [data.product_type]
        }]
      });
    }

    /**
     * The function `listenForCartChanges` overrides the `fetch` function in JavaScript to detect
     * specific URLs related to cart changes and update the local and global cart data.
     * @returns The function `listenForCartChanges` does not explicitly return anything.
     */
    function listenForCartChanges() {
      const cartUrls = [`/cart/add.js`, `/cart/add`]

      // Save the original fetch function
      const originalFetch = window.fetch

      // Override the fetch function
      window.fetch = function (url, options) {
        // Call the original fetch function
        return originalFetch.apply(this, arguments).then(async (response) => {
          if (cartUrls.includes(url)) {
            console.info('Fetch request to specific URL detected:', url)
            let clone = response.clone()
            clone.json().then(signalKlaviyo)

            // Fetch the updated cart data after the original fetch is completed
            const updatedCart = await getCart()

            // Update the local and global cart data
            cart = updatedCart
            window.cart = updatedCart

            console.info('Saved updated cart data to `window.cart`')
          }

          // Return the original response
          return response
        })
      }
    }


    async function init() {
      const cart = await getCart()
      console.info('CartSync initiated, saving cart data to `window.cart.data`')
      window.cart = {}
      window.cart.data = cart
      return cart
    }

    // Initiate, then save current cart data
    let cart = await init()

    listenForCartChanges()
  }

)()